<template>
  <div class="md:w-1/3">
    <div class="flex flex-col pl-6">
      <PaymentMethod />
      <PaymentSummary :membership-uuid="membershipUuid" />
    </div>
  </div>
</template>

<script type="text/babel">
import PaymentMethod from './PaymentMethod'
import PaymentSummary from './MembershipFeeSummary'

export default {
  name: 'MembershipPaymentInfo',
  components: {
    PaymentMethod,
    PaymentSummary,
  },
  props: {
    membershipUuid: {
      type: String,
      required: true,
    },
  },
}
</script>
